import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import UserRoleCreateUpdate from "../../components/RolePermission/UserRoleCreateUpdate";

const UserRoleCreateUpdatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <UserRoleCreateUpdate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default UserRoleCreateUpdatePage;